import { useEffect, useState } from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { VisitBadge } from '../badge';
import { Loading } from '../loading';
import { styles } from '../../constants';
import { isActive } from './shared';

export const VisitsList = ({ job }) => {
  const [now, setNow] = useState(Date.now());
  const childJobs = job?.children?.jobs || job?.children || [];

  const visitJobs = childJobs.filter((it) => it.name == 'visit');
  const running = visitJobs.filter((it) => it.state == 'active');

  useEffect(() => {
    if (!running.length) {
      return;
    }

    setNow(Date.now());
    const interval = setInterval(() => setNow(Date.now()), 45);
    return () => clearInterval(interval);
  }, [running.length]);

  const nodes = visitJobs
    .sort((a, b) => b.started - a.started)
    .filter((it) => isActive(job) || it.statuses.length)
    .slice(0, 100)
    .map((it) => {
      const label = it.state == 'active' ? 'Loading' : 'Visited';
      const loading = it.state == 'active' && <Loading size={14} />;
      const badge = it.state != 'active' && <VisitBadge statuses={it.statuses} />;
      const elapsed = Math.max((it.finished || now) - it.started, 0);

      const ext = <FaExternalLinkAlt size={10} />;

      let body;
      if (it.title) {
        body = (
          <a href={it.url} target="_blank">
            {it.title} {ext}
          </a>
        );
      } else {
        body = (
          <a href={it.url} target="_blank">
            {it.url} {ext}
          </a>
        );
      }

      return (
        <div style={{ display: 'flex', gap: 5, alignItems: 'center', whiteSpace: 'nowrap' }}>
          {loading}
          {badge}
          {label}
          <div
            style={{
              flex: 1,
              minWidth: 0,
              ...styles.textOverflowStyle,
            }}
          >
            {body}
          </div>
          <div style={{ fontSize: 'small', color: '#888' }}>{(elapsed / 1000).toFixed(2)}s</div>
        </div>
      );
    });

  if (!isActive(job) && nodes.length == 0) {
    return null;
  }

  return (
    <div>
      <div style={styles.stickyHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <div>
            <b>{visitJobs.length}</b> {visitJobs.length == 1 ? 'page' : 'pages'} visited
          </div>
          {running.length > 0 && <Loading size="xs" />}
        </div>
      </div>

      {nodes}
    </div>
  );
};
